module.exports = __webpack_public_path__ + "img/logo.481be254.jpg";